import "@/App.css";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import Anxiety from "@/components/site/Anxiety";
import Winston from "@/components/site/Winston";
import Services from "@/components/site/Services";
import KidsOffer from "@/components/site/KidsOffer";
import Gallery from "@/components/site/Gallery";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  return (
    <div className="App bg-pd-bg">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Anxiety />
        <Winston />
        <Services />
        <KidsOffer />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
